export const SHOP_SEARCH_MODE = {
    SEARCH_BY_TEXT: 'search_by_text',
    SEARCH_BY_FLOOR: 'search_by_floor',
    SEARCH_BY_CATEGORY: 'search_by_category',
} as const;

export type SHOP_SEARCH_MODE = (typeof SHOP_SEARCH_MODE)[keyof typeof SHOP_SEARCH_MODE];
